import { LatLng } from '../utility/gridJob';
import { del, get, post, put } from '../utility/http';
import { METER_SYSTEM } from '../utility/proj_util';

export async function fetchMarkers(project: string) {
  try {
    const response = await get(
      `/layers/projects/${project}/markers`,
      true,
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchMarkerDetail(body: any) {
  try {
    const response = await get(
      `/layers/projects/${body.project}/markers/${body.id}`,
      true,
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function addMarker(body: any) {
  try {
    const response = await post(
      `/layers/projects/${body.project}/markers`,
      true,
      {},
      body
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function editMarker(body: any) {
  try {
    const response = await put(
      `/layers/projects/${body.project}/markers/${body.id}`,
      true,
      {},
      body
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function removeMarker(body: any) {
  try {
    const response = await del(`/layers/projects/${body.project}/markers/${body.id}`, true, {});
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchSolids(project: string) {
  try {
    const response = await get(
      `/layers/projects/${project}/solids`,
      true,
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function addSolid(body: any) {
  try {
    const response = await post(
      `/layers/projects/${body.project}/solids`,
      true,
      {},
      body
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function removeSolid(body: any) {
  try {
    const response = await del(`/layers/projects/${body.project}/solids/${body.id}`, true, {});
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function planningGridAsyncMod(coords: LatLng[], demName: string,
  terrainFollow: boolean,
  samplingStep: number, projection: string,
  alsoTerrain:boolean, altitude: number[]|undefined) {
  try {
    const locations: any[] = [];
    coords.map((coord, index)=>{
      const el: any = {lat: coord.latitude, lng: coord.longitude};
      if (altitude){
        el.alt = altitude[index];
      }
      locations.push(el);
    });

    let url = '/quota/getElevationForLocations?';
    url += `terrainFollow=${(terrainFollow??false)}`;
    url += `&projection=${projection}&alsoTerrain=${alsoTerrain}`;
    if (demName && demName!=''){
      url += `&demName=${demName}`;
    }

    if (terrainFollow == true && samplingStep!=-1){
      url += `&samplingStep=${samplingStep}`;
    }

    const response : any  = await post(url,
      true, {}, locations, false, true);
    return response;
  } catch (e: any) {
    console.log(e);
    return {error: e.response ? e.response : e};
  }
}


export async function planningMaxMinAsyncMod(coords: LatLng[],
  demName: string,
  projection: string) {
  try {
    const locations: any[] = [];
    coords.map((coord)=>{
      locations.push(  {lat: coord.latitude, lng: coord.longitude} );
    });




    const response : any  = await post(
      `/quota/getStatsAlongPath?projection=${projection}&demName=${demName}`,
      true, {}, locations, false, true);
    return response;
  } catch (e: any) {
    //console.log(e);
    return {error: e.response ? e.response : e};
  }
}


export async function planningInnerAsyncMod(  taskId: string,
  geometry: any) : Promise<any> {
  try {

    const response : any  = await post('/data/isInside',
      true,{}, { taskId: taskId, geometry: geometry}, false, true);
    return response;
  } catch (e: any) {
    //console.log(e);
    return {error: e.response ? e.response : e};
  }
}



export async function planningWayPointActions(points: any[] ) {
  try {
    const response : any  =
      await post(`/asset-management/actions/toDroneActions?projection=${METER_SYSTEM}`,
        true, {}, points);
    return response?.data;
  } catch (e: any) {
    //console.log(e);
    return {error: e.response ? e.response : e};
  }
}

export async function planningGridAsync(coords: LatLng[], demName: string,
  terrainFollow: boolean,
  samplingStep: number , alsoTerrain:boolean, altitudine: number[]) {
  /*if (!terrainFollow){
    const locations: any[] = [];
    coords.map((coord)=>{
      locations.push({
        elevation: 0,
        location: {lat: coord.latitude, lng: coord.longitude}}
      );
    });
    return {data: { quotas: locations}};
  }*/
  return planningGridAsyncMod(coords, demName, terrainFollow, samplingStep,
    METER_SYSTEM, alsoTerrain, altitudine);
}
